//import Portis from "@portis/web3";
import WalletConnectProvider from "@walletconnect/web3-provider";
//import Authereum from "authereum";
//import Fortmatic from "fortmatic";
//import WalletLink from "walletlink";
import Web3Modal from "web3modal";
import { ALCHEMY_KEY, INFURA_ID, NETWORKS } from "../constants";

// Coinbase walletLink init
// const walletLink = new WalletLink({
//   appName: "coinbase",
// });

// WalletLink provider
 // const walletLinkProvider = walletLink.makeWeb3Provider("https://api.harmony.one", 1666600000);


// Portis ID: 6255fb2b-58c8-433b-a2c9-62098c05ddc9
/**
  Web3 modal helps us "connect" external wallets:
**/
const web3ModalSetup = () =>
  new Web3Modal({

    network: "mainnet", // Optional.
    cacheProvider: true, // optional
    theme: "dark", // optional. Change to "dark" for a dark theme.
    providerOptions: {

      // walletconnect: {
      //   package: WalletConnectProvider, // required
      //   options: {
      //     bridge: "https://bridge.walletconnect.org",
      //     infuraId: "",
      //     qrcode: true,
      //     chainId: 1666600000,
      //     rpc: {
      //
      //
      //
      //
      //       1666600000 : "https://api.harmony.one",
      //     },
      //   },
      // },
    },
  });

export default web3ModalSetup;
